<template lang="pug">
  v-layout(align-start)
    v-flex
      v-data-table.elevation-1(:headers='headers' item-key='cxc' :items='cxc' :search='search' sort-by='codigo' :loading='loading' loading-text='Cargando, por favor espere...')
        template(v-slot:top)
          v-toolbar(flat color='primary' dark)
            v-toolbar-title Estados de Cuentas
            v-divider.mx-4(inset vertical)
            v-spacer
            v-text-field.text-xs-center(v-model='search' label='Búsqueda' single-line hide-details color='success')
            v-spacer
            v-dialog(v-model='dialog', persistent='', max-width='40%')
            CuentaXCobrarM(:dialog='dialog' :editedIndex='editedIndex' @close='close' :read='read' :FormPadre='form' @save='listarCuentasXCobrar' @edited='listarCuentasXCobrar')
            MostrarPagos(:dialog2='dialog2' @close='close' :read='read' :FormPadre='pagosPorCxcArray' )
        template(v-slot:item.action='{ item }')
          v-tooltip(bottom='')
            template(v-slot:activator='{ on }')
              v-icon.mr-2(v-if="item.estatusPago === 'Pendiente'"  color='success' @click='editItem(item, false)' v-on="on") mdi-cash-usd
            | Cobrar
          v-tooltip(bottom='')
            template(v-slot:activator='{ on }')
              v-icon.mr-2(color='primary_2' @click='editItem(item, true)' v-on="on") mdi-eye
            | Confirmaciones
        template(v-slot:no-data='')
          h1 No hay Cuentas por Cobrar Asociadas
</template>

<script>
import Api from '@/services/methods'
import CuentaXCobrarM from '../components/modals/CuentaXCobrarM'
import MostrarPagos from '../components/modals/MostrarPagos'
export default {
  data: () => ({
    dialog: false,
    dialog2: false,
    read: false,
    loading: true,
    headers: [
      { text: 'Número Factura', align: 'left', sortable: false, value: 'idVenta.numFactura' },
      { text: 'Cliente', value: 'idCliente.nombre' },
      { text: 'Rif Cliente', value: 'idCliente.rif' },
      { text: 'Fecha Vencimiento', value: 'fechaVencimiento' },
      { text: 'Días Deuda', value: 'moroso' },
      { text: 'Debito', value: 'debito' },
      { text: 'Credito', value: 'credito' },
      { text: 'Tipo de Venta', value: 'tipoVenta' },
      { text: 'Concepto', value: 'idConcepto.nombre' },
      { text: 'Estatus', value: 'estatusPago' },
      { text: 'Acciones', value: 'action', align: 'right', sortable: false }
    ],
    search: '',
    cxc: [],
    pago: [],
    clientes: [],
    pagosPorCxcArray: [],
    permisosRuta: {},
    editedIndex: -1,
    estatus: [{ value: false, text: 'No' }, { value: true, text: 'Si' }],
    form: {},
    defaultItem: {}
  }),

  components: {
    CuentaXCobrarM,
    MostrarPagos
  },
  computed: {
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  created () {
    this.initialize()
    // this.permisosRuta = this.$store.state.empresa[0].permisos.find(permiso => permiso.ruta == "Almacen")
  },
  methods: {

    initialize () {
      this.listarCuentasXCobrar()
      this.listarPagos()
    },
    // validarCrear(){
    //   return this.permisosRuta.accion.includes('Crear')
    // },

    // validarModificar(){
    //   return this.permisosRuta.accion.includes('Modificar')
    // },

    // validarEliminar(){
    //   return this.permisosRuta.accion.includes('Eliminar')
    // },

    formato (fecha) {
      return fecha.substr(0, 10)
    },
    decimal (val) {
      return Number.parseFloat(val).toFixed(2)
    },
    listarCuentasXCobrar () {
      Api.get('cuentaporcobrar')
        .then(response => {
          this.cxc = response.data
          this.clientesCXC(response.data)
          let hoy = new Date()
          let moroso
          this.cxc.map((data, i) => {
            if (data.debito === 0) {
              this.cxc[i].estatusPago = 'Cancelada'
            } else {
              this.cxc[i].estatusPago = 'Pendiente'
            }
            data.fechaRegistro = this.formato(data.fechaRegistro)
            data.fechaVencimiento = this.formato(data.fechaVencimiento)
            data.fechaCierreFactura = this.formato(data.fechaCierreFactura)
            let fecha = this.$moment(hoy)
            let fecha2 = this.$moment(data.fechaVencimiento)
            moroso = fecha.diff(fecha2, 'days')
            if (moroso <= 0) this.cxc[i].moroso = 0
            else this.cxc[i].moroso = moroso
            data.debito = this.decimal(data.debito)
            data.credito = this.decimal(data.credito)
          })
          this.loading = false
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    listarPagos () {
      Api.get('/pago')
        .then(response => {
          this.pago = response.data
          this.pago.map(data => {
            if (data.confirmacion) data.confirmado = 'Confirmado'
            else data.confirmado = 'No Confirmado'
          })
          this.loading = false
        })
        .catch(e => {
          console.log('error' + e)
          this.permissDenied(e.response.status)
        })
    },

    clientesCXC (cxc) {
      cxc.map(data => {
        if (this.clientes.length === 0) {
          this.clientes.push(data.idCliente)
        } else {
          let bool = false
          for (let i = 0; i < this.clientes.length; i++) {
            if (data.idCliente._id !== this.clientes[i]._id) {
              bool = true
            } else {
              bool = false
              break
            }
          }
          if (bool) {
            this.clientes.push(data.idCliente)
          }
        }
      })
    },

    pagosPorCxc (cxc) {
      this.pago.map((pag) => {
        if (pag.idVenta._id === cxc.idVenta._id) {
          this.pagosPorCxcArray.push(pag)
        }
      })
    },

    numberPDF (num) {
      return Number.parseFloat(num).toFixed(2)
    },

    editItem (item, confirmacion) {
      if (!confirmacion) {
        this.editedIndex = this.cxc.indexOf(item)
        this.form = Object.assign({}, item)
        this.dialog = true
      } else {
        this.pagosPorCxc(item)
        this.dialog2 = true
      }
    },
    deleteItem (item) {
      const index = this.cxc.indexOf(item)
      this.$swal({
        icon: 'warning',
        title: '¿Seguro que quiere borrar?',
        text: 'No podrá revertir',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, borrar',
        cancelButtonText: 'cancelar'
      }).then(result => {
        if (result.value) {
          this.$swal('Borrado!', 'Su registro fue borrado.', 'success')
          this.cxc.splice(index, 1)
          Api.put('/cxc/deletelog/' + item._id).then(response => {
          })
        }
      })
    },
    close () {
      this.dialog = false
      this.dialog2 = false
      setTimeout(() => {
        this.form = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    permissDenied (status) {
      if (status === '403') {
        this.$swal({
          icon: 'error',
          title: 'Permiso denegado',
          text: 'No tiene pemisos suficientes para ver esta página',
          allowOutsideClick: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ok',
          onAfterClose: () => {
            window.location.href = '/home'
          }
        })
      }
    }

  }
}
</script>
